import { render, staticRenderFns } from "./TapiConfigPage.vue?vue&type=template&id=40220b04&"
import script from "./TapiConfigPage.vue?vue&type=script&lang=js&"
export * from "./TapiConfigPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports